import * as React from 'react';
import { AppBar, Container, Toolbar } from '@mui/material';
import blueLogo from 'assets/images/companyLogo.svg'



function PolicyHeader() {
  
  return (
    <AppBar position="static" className="bgColorBlue boxShadowNone">
      <Container maxWidth="xl" className='height100'>
        <Toolbar disableGutters>
          <img src={blueLogo} alt='blueLogo' className='logoImage marginTop'/>  
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default PolicyHeader;